
export const text = `The second item to be aware of is the props of the video. If anything has been replaced by a knife, an infathomable number of eyes, a floodlight flashing in morse code, or someone looking directly into the screen from more than six feet away from the perspective, please try clicking the settings button in the bottom of the video and adjusting to 190p. If 190p is not available, you are safe. If it is available, don't. You are not on Youtube. You may not be on the internet. Are you in your house? Are you in my house? Run.



`